<template>
  <div>
    <div class="flex flex-row items-center justify-between gap-2">
      <DropdownFilter
          class="flex-1"
          v-for="(item,index) in filterCondition"
          :key="index"
          :place-holder="item.placeHolder"
          :value="item.value"
          @onCancel="onCancel"
          @onApply="onApply"
          @input="(selectedIndex,val) => onInput(index,selectedIndex,val)"
          :options="item.options"/>
    </div>
  </div>
</template>


<script>
import WriteDataItem from "@/components/WriteDataItem";
import DropdownFilter from "@/components/DropdownFilter";

export default {
  name: "SearchFilter",
  components: { DropdownFilter, WriteDataItem },
  props: {
    filterCondition: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      searchContent: ""
    };
  },
  methods: {
    onInput(index,selectedIndex,val) {
      this.$emit("onItemSelectedChange", index,selectedIndex,val);
    },
    onCancel() {
      this.$emit('onCancel')
    },
    onApply(findSelected) {
      this.$emit('onApply', findSelected);
    }
  }
};
</script>
<style scoped lang="less">

</style>